import {useState} from 'react';
import axios from 'axios';
import {Button, Modal, Form, Dropdown, ButtonGroup} from 'react-bootstrap';
import {Envelope} from 'react-bootstrap-icons';


const EnviaEmail = (props) => {
    //console.log('funcion EnviaEmail ', props )
    const id_cliente = props.celdas.num;
    const email_ok = props.celdas.email_ok;
    
    const [show, setShow] = useState(false);
    //const [nombre_cliente, setNombre_cliente] = useState('');
    //const [email_cliente, setEmail_cliente] = useState('');
    //const [subject, setSubject] = useState('');
    //const [body, setBody] = useState('');
    const [formCorreo, setFormCorreo] = useState({
        nombre_cliente: '',
        email_cliente: '',
        subject: '',
        body: ''
    });

    const handleClose = () => setShow(false);
    const handleShow = () => {

        const token = localStorage.getItem('token');
        axios({
        method: "POST",
        url:"/api/getclienteemail",
        headers: {
        Authorization: 'Bearer ' + token
        },
        data: {
            id_cliente: id_cliente
        }
      })
      .then((response) => {
        console.log(response.data.datos);
        setFormCorreo({
            nombre_cliente: response.data.datos[0].nombre_cliente,
            email_cliente: response.data.datos[0].email,
            subject: response.data.datos[0].subject,
            body: response.data.datos[0].body
        });
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data.msg)
          }
      })
        
        setShow(true)
    
    };

    const grabaForm = () => {
        //setShow(false);
        console.log('funcion guardaForm ', formCorreo) 
        const token = localStorage.getItem('token');
        const datosCorreo = {
            destinatario: formCorreo.email_cliente,
            asunto: formCorreo.subject,
            contenido: formCorreo.body
        }
        axios({
            method: "POST",
            url:"/api/envia_email",
            headers: {
            Authorization: 'Bearer ' + token
            },
            data: datosCorreo
          })
          .then((response) => {
            console.log('axios: ', response.data.msg);
            if (response.data.error) {
              alert(response.data.msg)
            }else{
              alert(response.data.msg)
              setShow(false);
            }
          }).catch((error) => {
            if (error.response) {
              console.log(error.response)
              console.log(error.response.status)
              console.log(error.response.headers)
              }
        })
        //window.location.reload(false);
    }

    function cambioEnForm (event) {
    const {value, name} = event.target;
    setFormCorreo(prevNote => ({...prevNote, [name]: value}))
  }

    return (
        <>
            <button className="btn btn-outline-primary" size="sm" onClick={handleShow} disabled={email_ok=='No'} ><Envelope /></button>
            <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title><h3>Enviar email</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label><span className="campo">Cliente</span></Form.Label>
                                <Form.Control
                                    name="nombre_cliente"
                                    type="text"
                                    placeholder={formCorreo.nombre_cliente}
                                    autoFocus
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label><span className="campo">Email</span></Form.Label>
                                <Form.Control
                                    name="email_cliente"
                                    type="email"
                                    placeholder={formCorreo.email_cliente}
                                    autoFocus
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label><span className="campo">Asunto</span></Form.Label>
                                <Form.Control 
                                    name="subject"
                                    type="text"
                                    value={ formCorreo.subject }
                                    placeholder={formCorreo.subject}
                                    autoFocus
                                    onChange={cambioEnForm}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label><span className="campo">Mensaje</span></Form.Label>
                                <Form.Control as="textarea" rows={6}
                                    name="body"    
                                    value={ formCorreo.body }                               
                                    placeholder={ formCorreo.body }
                                    autoFocus
                                    onChange={cambioEnForm}
                                />
                            </Form.Group>
                        </Form>
                        </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="secondary" onClick={handleClose}>
                                    Cancelar
                                  </Button>
                                  <Button variant="primary" onClick={grabaForm}>
                                    Enviar email
                                  </Button>
                                </Modal.Footer>
                    </Modal>
        </>
    )
}

export default EnviaEmail